import { FC, useEffect } from 'react';
import { useRouter } from 'next/router';

import { useAuth } from '../../../context/authContext/AuthContext';

export const ActionsHandler: FC = ({ children }) => {
  const router = useRouter();
  const {query} = router;
  const redirectTo = query.redirectTo || '';
  const auth = useAuth();

  useEffect(() => {
    const redirectedFrom = query.from;
    if (redirectedFrom) {
      auth.login(redirectedFrom as string);
    }
  }, [query]);

  if (redirectTo) {
    router.push(redirectTo as string);
    return <p>Redirecting to {redirectTo}</p>;
  }

  return <>{children}</>;
};
